export const UNIT_TYPES_RENT = {
  apartment: 'entire_place',
  studio: 'entire_place',
  bedroom: 'bedrooms',
  bed: 'bed'
};

export const PROPERTY_UNIT_TYPE = {
  APARTMENT: 'apartment',
  STUDIO: 'studio',
  BEDROOM: 'bedroom',
  BED: 'bed',
  HOUSE: 'house'
};

export const UNIT_TYPES = {
  BEDROOM: 'bedroom',
  BATHROOM: 'bathroom',
  KITCHEN: 'kitchen',
  LIVING_ROOM: 'living-room',
  WC: 'wc'
};

export const SUBUNIT_TYPES = {
  ENCLOSED_BALCONY: 'enclosed_balcony',
  KITCHEN: 'kitchen',
  BATHROOM: 'bathroom',
  SINGLE_BED: 'single-bed',
  DOUBLE_BED: 'double-bed',
  TWIN_BED: 'twin-bed',
  MULTIPLE_BED: 'multiple-bed',
  WC: 'wc'
};
